(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2773"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2773"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cHW0f", function(module, exports) {
/* eslint-disable */ const $94067e6194b8da36$var$refHeaderWidth = 1100;
jQuery(function($) {
    const links = $('.Header-menu #menu-menu-principal > li > a').toArray();
    if (window.location.pathname !== '/') links.forEach((link)=>{
        if (link.href.includes(window.location.pathname)) link.classList.add('active');
    });
    $(window).on('resize', function() {
        if (window.innerWidth > $94067e6194b8da36$var$refHeaderWidth) // $('.Header-hamburger').removeClass('active');
        $('.Header-menu').removeClass('open');
    });
    $('.Header-search #search').on('keyup', function() {
        const search = $(this).val();
        if (search !== '') $(this).parent().children('.btnClear').show();
        else $(this).parent().children('.btnClear').hide();
    });
    $('#search-button').on('click', function() {
        $('.Header-search').css('display', 'flex');
        document.getElementById("search").focus();
        const search = $('#search').val();
        $('#search').val('');
        $('#search').val(search);
        if (search !== '') $('.btnClear').show();
        else $('.btnClear').hide();
    });
    $('.Header-search #close').on('click', function() {
        $('.Header-search').hide();
    });
    $('.btnClear').on('click', function() {
        $('.Header-search #search').val('');
        $(this).hide();
        document.getElementById("search").focus();
    });
});

});

parcelRegister("1COhW", function(module, exports) {

$parcel$export(module.exports, "stopTrackCrossOrigin", function () { return $12f0594221b780dc$export$ff66a007e3de4ce0; });
const $12f0594221b780dc$export$ff66a007e3de4ce0 = ()=>{
    const allWarningButtons = document.querySelectorAll('.warning-button, .no-class-link');
    allWarningButtons.forEach((button)=>{
        if (button.href) {
            const originalUrl = button.href;
            button.addEventListener('click', function(event) {
                event.preventDefault();
                event.stopImmediatePropagation();
                window.open(originalUrl, '_blank');
            }, true);
        }
    });
};
$12f0594221b780dc$export$ff66a007e3de4ce0();

});

parcelRegister("7m9Ie", function(module, exports) {
(function() {
    function getUTMParams() {
        const params = new URLSearchParams(window.location.search);
        const utms = {};
        for (const [key, value] of params.entries())if (key.startsWith("utm_")) utms[key] = value;
        return utms;
    }
    const currentUTMs = getUTMParams();
    if (Object.keys(currentUTMs).length > 0) sessionStorage.setItem("utmParams", JSON.stringify(currentUTMs));
    function getStoredUTMParams() {
        const stored = sessionStorage.getItem("utmParams");
        return stored ? JSON.parse(stored) : {};
    }
    function appendUTMsToLink(link) {
        const utms = getStoredUTMParams();
        if (Object.keys(utms).length === 0) return;
        const url = new URL(link.href);
        for(const key in utms)url.searchParams.set(key, utms[key]);
        link.href = url.toString();
    }
    document.addEventListener("DOMContentLoaded", function() {
        const botoes = document.querySelectorAll('a.subscribe-button, a[href*="cgi.insper.edu.br/Inscricao/lead"]');
        botoes.forEach((link)=>{
            appendUTMsToLink(link);
        });
    });
})();

});

/* Base Bundle - Scripts comuns a todas as páginas */ parcelRequire("cHW0f");
parcelRequire("1COhW");
parcelRequire("7m9Ie");

})();
//# sourceMappingURL=base.js.map
